import * as types from "../redux/types";
import backend from "../api/api";
import { store } from "../redux/store";
import { message } from "antd";

// Auth header for secure API calls
const getConfig = () => {
  const token = store.getState().auth.token;
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

//  Get Device List from Biotime via Django proxy
export const getDeviceList = () => async (dispatch) => {
  try {
    const response = await backend.get("api/hrm/biotime/terminals/", getConfig());
    console.log("Device list fetched successfully:", response.data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching device list:", error);
    message.error("Failed to fetch device list");
    return [];
  }
};

// Trigger Biotime manual sync via Django
export const syncBiotimeManual = () => async () => {
  try {
    const response = await backend.get("api/hrm/biotime/manual-sync/", getConfig()); 
    if (response.status === 200) {
      message.success("Sync completed successfully");
      return response.data;
    }
  } catch (error) {
    console.error("Biotime sync error:", error);
    message.error("Sync failed. Check Biotime server.");
  }
};

// Check Biotime Server (via Django HTTPS-safe endpoint)
export const checkBiotimeServer = async () => {
  try {
    const response = await backend.get("api/hrm/biotime/check-server-status/", getConfig());
    const data = response.data;
    console.log("Biotime server status:", data);
    return data && data.status === "online";
  } catch (e) {
    console.error("Server check failed:", e);
    return false;
  }
};